<template>
    <div>
        <div class="main-right" v-show="switchVal">
            <el-card class="side-right">
                <div class="right-title">
                    <p style="font-weight: 600">默认弹出此侧边栏</p>
                    <el-switch v-model="switchVal" active-color="#2448FF" inactive-color="#999"> </el-switch>
                </div>
                <el-input placeholder="搜索相关问题" @focus="show" v-model="rightSearchVal" class="input-with-select" style="margin: 20px 0">
                    <el-button size="small" slot="append" icon="el-icon-search"></el-button>
                </el-input>
                <p style="font-weight: 600">常见问题</p>
                <div class="silde">
                    <div v-if="dataList.length > 0">
                        <el-collapse v-model="proActiveName" accordion>
                            <el-collapse-item :title="item.title" :name="index" v-for="(item, index) in dataList" :key="index">
                                <div v-html="item.content"></div>
                            </el-collapse-item>
                        </el-collapse>
                        <el-link type="primary" @click="show">查看更多</el-link>
                    </div>
                    <div v-else>
                        <el-empty description="暂无内容！"></el-empty>
                    </div>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            switchVal: true,
            rightSearchVal: "",
            proActiveName: "",
        };
    },
    props: ["dataList"],
    methods: {
        show() {
            this.$emit("show");
        },
    },
};
</script>

<style lang="scss" scoped>
.main-right {
    flex-shrink: 0;
    width: 208px;
    margin-top: 24px;
    height: calc(100% - 24px);
}
.el-card {
    margin: 0;
    margin-bottom: 24px;
    padding: 15px;
    height: calc(100% - 24px);
}
.right-title {
    display: flex;
    justify-content: space-between;
}
.silde {
    padding-left: 20px;
    margin-top: 15px;
    .el-collapse {
        border: 0;
        ::v-deep .el-collapse-item__header {
            height: auto;
            line-height: 26px;
            background-color: #fff;
            color: #303133;
            cursor: pointer;
            font-size: 14px;
            border: 0;
            font-weight: 500;
            transition: border-bottom-color 0.3s;
            outline: 0;
            position: relative;
            i {
                display: none;
            }
            &::before {
                content: "";
                position: absolute;
                left: -20px;
                top: 10px;
                border: 6px solid;
                border-color: #666 transparent transparent transparent;
                transition: transform 0.3s;
                transform-origin: center 25%;
            }
        }
        ::v-deep .el-collapse-item__wrap {
            border: 0 !important;
        }
        ::v-deep .el-collapse-item {
            margin-bottom: 14px;
        }
        .el-collapse-item.is-active {
            ::v-deep .el-collapse-item__header {
                &::before {
                    transform: rotateZ(180deg);
                }
            }
        }
    }
}
</style>